import { Pipe, PipeTransform } from '@angular/core';
import {
  AVAILABLE_BROWSERS,
  BROWSERS_VERSION,
  TECHNOLOGICAL_PLATFORM,
} from 'src/app/core/helpers/ui/ui.constant';

@Pipe({
  name: 'clientEnvironment',
})
export class BuildClientEnvironmentPipe implements PipeTransform {
  transform(row: any): string {
    const clienthinstValue = row?.clientHints;
    if (!clienthinstValue) return '—';

    const browser = this.browserFromSecChUa(clienthinstValue.secChUa);
    const platform = clienthinstValue.secChUaPlatform ?? TECHNOLOGICAL_PLATFORM.UNKNOWN;
    const device =
      clienthinstValue.secChUaMobile === true || clienthinstValue.secChUaMobile === '?1'
        ? TECHNOLOGICAL_PLATFORM.MOBILE
        : TECHNOLOGICAL_PLATFORM.DESKTOP;

    return `${browser} · ${platform} · ${device}`;
  }

  private browserFromSecChUa(secChUa?: string): string {
    if (!secChUa) return AVAILABLE_BROWSERS.UNKNOWN;

    const ua = secChUa.toLowerCase();

    if (ua.includes(BROWSERS_VERSION.EDGE)) {
      return this.version(secChUa, 'Microsoft Edge', AVAILABLE_BROWSERS.EDGE);
    }

    if (ua.includes(BROWSERS_VERSION.BRAVE)) {
      return this.version(secChUa, 'Brave', AVAILABLE_BROWSERS.BRAVE);
    }

    if (ua.includes(BROWSERS_VERSION.CHROME)) {
      return this.version(secChUa, 'Google Chrome', AVAILABLE_BROWSERS.CHROME);
    }

    if (ua.includes(BROWSERS_VERSION.OPERA)) {
      return this.version(secChUa, 'Opera', AVAILABLE_BROWSERS.OPERA);
    }

    if (ua.includes(BROWSERS_VERSION.CHROMIUM)) {
      return this.version(secChUa, 'Chromium', AVAILABLE_BROWSERS.CHROMIUM);
    }

    return AVAILABLE_BROWSERS.UNKNOWN;
  }

  private version(header: string, name: string, browser: string): string {
    const regex = new RegExp(`"${name}";v="(\\d+)"`, 'i');
    const match = header.match(regex);
    return match ? `${browser} ${match[1]}` : browser;
  }
}
